import Popup from './src/popup';

export default Popup;



// WEBPACK FOOTER //
// ./src/components/popup/index.js